export const SCOPE = {
  READ_PROFILE: 'openid',
  WRITE_PROFILE: 'write:profile',
  READ_CARD: 'read:card',
  WRITE_CARD: 'write:card',
  OFFLINE_ACCESS: 'offline_access'
}
